/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SecurityScanExample } from '../models/SecurityScanExample';

export class SecurityScanResult {
  /**
  * The security evidence type.
  */
  'evidenceType': SecurityScanResultEvidenceTypeEnum;
  /**
  * Number of evidences of this type
  */
  'count': number;
  /**
  * Examples of the evidence found
  */
  'examples'?: Array<SecurityScanExample>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "evidenceType",
      "baseName": "evidenceType",
      "type": "SecurityScanResultEvidenceTypeEnum",
      "format": ""
    },
    {
      "name": "count",
      "baseName": "count",
      "type": "number",
      "format": ""
    },
    {
      "name": "examples",
      "baseName": "examples",
      "type": "Array<SecurityScanExample>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SecurityScanResult.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum SecurityScanResultEvidenceTypeEnum {
  SuspiciousExtensionDetected = 'suspicious_extension_detected',
  SuspiciousActivityDetected = 'suspicious_activity_detected',
  ModifiedFilesBecameEncrypted = 'modified_files_became_encrypted',
  MalwareDetected = 'malware_detected',
  TableDeletion = 'table_deletion',
  SignificantRowDecrease = 'significant_row_decrease',
  HighChangePercentage = 'high_change_percentage'
}

